var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { faChevronDown, faChevronRight, faExclamationCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Icon, Row } from "antd";
import React, { useEffect, useState } from "react";
import { Legends } from "./legends";
import { TTRTimeline } from "./timeline";
export var TTRBox = function (_a) {
    var data = _a.data, activeTTR = _a.activeTTR, nonActiveTTR = _a.nonActiveTTR, collapse = _a.collapse;
    var _b = useState(), activeVisible = _b[0], setActiveVisible = _b[1];
    var _c = useState(), nonActiveVisible = _c[0], setNonActiveVisible = _c[1];
    useEffect(function () {
        if (collapse) {
            if (activeVisible === undefined)
                setActiveVisible(collapse === null || collapse === void 0 ? void 0 : collapse.active);
            if (nonActiveVisible === undefined)
                setNonActiveVisible(collapse === null || collapse === void 0 ? void 0 : collapse.nonActive);
        }
    }, [collapse]);
    return (React.createElement("div", { className: "ttr-box", style: { width: "100%" } },
        activeTTR && activeTTR.length > 0 ?
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "ttr-status-banner ".concat(collapse ? "cursor-pointer" : ""), onClick: function () { return collapse && setActiveVisible(!activeVisible); } },
                    "(",
                    activeTTR.length,
                    ") Open",
                    collapse && React.createElement(FontAwesomeIcon, { icon: (activeVisible !== null && activeVisible !== void 0 ? activeVisible : true) ? faChevronDown : faChevronRight, className: "margin-left-xs" })))
            :
                null,
        activeTTR && (activeVisible !== null && activeVisible !== void 0 ? activeVisible : true) && activeTTR.map(function (uuid, index) {
            return data[uuid] ? React.createElement(React.Fragment, { key: index },
                React.createElement(TTRItem, __assign({}, data[uuid]))) : null;
        }),
        nonActiveTTR && nonActiveTTR.length > 0 ?
            React.createElement("div", { className: "ttr-status-banner ".concat(collapse ? "cursor-pointer" : ""), onClick: function () { return collapse && setNonActiveVisible(!nonActiveVisible); } },
                "(",
                nonActiveTTR.length,
                ") Closed",
                collapse && React.createElement(FontAwesomeIcon, { icon: (nonActiveVisible !== null && nonActiveVisible !== void 0 ? nonActiveVisible : true) ? faChevronDown : faChevronRight, className: "margin-left-xs" }))
            :
                null,
        nonActiveTTR && (nonActiveVisible !== null && nonActiveVisible !== void 0 ? nonActiveVisible : true) && nonActiveTTR.map(function (uuid, index) {
            return data[uuid] ? React.createElement(React.Fragment, { key: index },
                React.createElement(TTRItem, __assign({}, data[uuid]))) : null;
        })));
};
export var TTRItem = function (item) {
    return (React.createElement("div", { className: "ttr-box-item" },
        React.createElement(Row, { style: { display: "flex" } },
            React.createElement(Col, { style: { flex: 1 } },
                React.createElement("div", { className: "ttr-header", style: { display: "flex" } },
                    item.icon && React.createElement("div", { className: "padding-right-sm" },
                        React.createElement(Icon, { className: "color-".concat(item.iconColor || 'blue'), style: { paddingTop: 5 }, component: function () { return React.createElement(FontAwesomeIcon, { size: '2x', icon: item.icon || faExclamationCircle }); } })),
                    React.createElement("div", { className: "padding-top-xs", style: { fontWeight: "bold" } },
                        React.createElement("div", { className: "ttr-header-title" }, item.title)))),
            React.createElement(Col, { style: { display: "flex" } },
                React.createElement("div", { className: "padding-left-xxl" },
                    React.createElement("div", { className: "ttr-info-sub-title" }, "Start date"),
                    React.createElement("div", { className: "ttr-info-title" }, item.startedOn)),
                React.createElement("div", { className: "padding-left-xxl" },
                    React.createElement("div", { className: "ttr-info-sub-title" }, "Impact (As On)"),
                    React.createElement("div", { className: "ttr-info-title" },
                        item.impact,
                        React.createElement("span", { className: "margin-left-xs" }),
                        "(",
                        item.impactAsOn || item.lastUpdated || '',
                        ")")),
                React.createElement("div", { className: "padding-left-xxl" },
                    React.createElement("div", { className: "ttr-info-sub-title" }, "Estimated resolution time"),
                    React.createElement("div", { className: "ttr-info-title" }, item.eta)))),
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement("div", { className: "ttr-main-description", dangerouslySetInnerHTML: { __html: item.description || '' } }))),
        (item.containers && item.containers.length !== 0) ? React.createElement("div", { className: "ttr-containers-section" },
            React.createElement(Legends, { list: item.containers.filter(function (value, index, self) {
                    return index === self.findIndex(function (t) { return (t.title === value.title); });
                }) })) : null,
        (item.timeline && item.timeline.length !== 0) ? React.createElement("div", { className: "ttr-timeline-section" },
            React.createElement(TTRTimeline, { timeline: item.timeline })) : null,
        React.createElement(Row, { className: "ttr-mute-text-section margin-top-xs" },
            React.createElement(Col, null,
                "Last updated: ",
                item.lastUpdated || 'N/A',
                " | Published on: ",
                item.publishedOn || 'N/A',
                " | Error code: ",
                item.errorCode || 'N/A'))));
};
export default TTRBox;
//# sourceMappingURL=index.js.map